import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiError } from './api';

const PUBLIC_PATHS = ['/login', '/reset-password', '/preinscription'];

/**
 * A 403 usually means the administration changed this role's rights (Paramètres › Rôles & permissions):
 * refetch `/me` so the menu, routes and <Can> buttons follow the new matrix right away.
 */
function onForbidden(error: unknown) {
  if (isApiError(error, 'FORBIDDEN')) void queryClient.invalidateQueries({ queryKey: ['me'] });
}

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({
    // Session expired and could not be refreshed: back to the login page, then return here after signing in.
    onError: (error) => {
      onForbidden(error);
      const path = window.location.pathname;
      if (!isApiError(error, 'UNAUTHENTICATED') || PUBLIC_PATHS.some((p) => path.startsWith(p))) return;
      queryClient.clear();
      window.location.assign(`/login?redirect=${encodeURIComponent(path + window.location.search)}`);
    },
  }),
  mutationCache: new MutationCache({ onError: onForbidden }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => !isApiError(error) || (error.status >= 500 && count < 2),
    },
  },
});
